import React, { ReactElement } from 'react';
import { GridColDef, GridValueFormatterParams } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridToolbar } from '@mui/x-data-grid-premium';
import { Typography } from '@mui/material';
import { CytokineDialog } from './Dialog';
import { DrugFilteredDataType } from './models'
import { COLOR_DARK } from './theme';

export function DrugGrid({ filteredData }: {
  filteredData:
  Array<DrugFilteredDataType>
}): ReactElement {

  const [open, setOpen] = React.useState(false);
  const [clickedCytokines, setClickedCytokines] = React.useState([]);

  const handleOpen = (params: any) => {
    setClickedCytokines(params.row.cytokines);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (filteredData.length === 0) return <></>

  const columns: GridColDef[] = [
    {
      field: 'drug',
      headerName: 'Drug Name',
      flex: 1,
      minWidth: 150,
      align: 'left'
    },
    {
      field: 'mean',
      headerName: 'Mean Efficacy',
      width: 130,
      align: 'center',
      valueFormatter: ({ value }) => value.toFixed(2)
    },
    {
      field: 'median',
      headerName: 'Median Efficacy',
      width: 120,
      align: 'center',
      valueFormatter: ({ value }) => value.toFixed(2)
    },
    {
      field: 'percent',
      headerName: '% Cytokines Targeted',
      width: 150,
      type: "number",
      align: 'center',
      valueFormatter: (params: GridValueFormatterParams<number>) => {
        if (params.value == null) { return '' }
        return `${Number(params.value * 100).toLocaleString()} %`;
      }
    },
    {
      field: 'kiss',
      headerName: 'Cytokine Inhibition Selectivity Score',
      width: 140,
      align: 'center',
      valueFormatter: ({ value }) => (typeof value === 'number') ? value.toFixed(2) : value
    },
    {
      field: 'fdaApproved',
      headerName: 'FDA Approved',
      width: 120,
      type: "string",
      align: 'center'
    },

  ];

  return (
    <>
      <Typography variant="h2" sx={{ mt: 4 }}>Drugs Associated With Search</Typography>
      <Typography variant="body1">Click on a row to view cytokines targeted by drug</Typography>
      <DataGridPro
        sx={{ height: '500px', mb: 6, mt: 2 }}
        rows={filteredData}
        getRowId={(row) => row.drug}
        columns={columns}
        components={{ Toolbar: GridToolbar }}
        density='compact'
        disableSelectionOnClick={true}
        componentsProps={{
          toolbar: {
            sx: {
              '& .MuiButtonBase-root': {
                color: COLOR_DARK,
              }
            },
          },
        }}
        pageSize={5}
        rowThreshold={0}
        onRowClick={handleOpen}
        initialState={{
          sorting: { sortModel: [{ field: 'mean', sort: 'desc' }] }
        }}
      />
      <CytokineDialog
        clickedCytokines={clickedCytokines}
        open={open}
        onClose={handleClose}
      />
    </>
  );
}
